/** SASADM-0170 — the one "this is turned off" text style (Operator: strikethrough, very grey). */
export const DISABLED_TEXT_SX = { textDecoration: 'line-through', color: 'text.disabled' } as const;
